/**
 * @module frest
 */
import * as tslib_1 from "tslib";
/**
 * Error representation class when there is any failure during request life-cycle.
 * @public
 */

var FrestError =
/** @class */
function (_super) {
  tslib_1.__extends(FrestError, _super);
  /* istanbul ignore next */


  function FrestError(message, frest, request, response) {
    var _this = _super.call(this, message) || this;

    _this.frest = frest;
    _this.request = request;
    _this.response = response;
    return _this;
  }

  return FrestError;
}(Error);

export { FrestError };